import React, {Component} from "react";

/**
 * This works in all modern browsers, including IE9+
 * See: https://stackoverflow.com/questions/11235206/twitter-bootstrap-form-file-element-upload-button/18164555#18164555
 */

const defaultStatusText = 'No files selected.';

class FancyFileUpload extends Component {
    constructor() {
        super();

        this.state = {
            statusText: defaultStatusText,
            selectedCount: 0,
            uploadVisible: false,
            uploadEnabled: false
        };

        this.onFileSelect = this.onFileSelect.bind(this);
        this.onUploadClick = this.onUploadClick.bind(this);
        this.clear = this.clear.bind(this);
    }

    onFileSelect() {
        const files = (this.filePicker.files ? [...this.filePicker.files]: []);
        if (0 === files.length) {
            this.setState({
                statusText: defaultStatusText,
                selectedCount: 0,
                uploadVisible: false
            });
        } else {
            this.setState({
                statusText: files.map(f => f.name).join(', '),
                selectedCount: files.length,
                uploadVisible: true,
                uploadEnabled: true
            });
        }
    }

    onUploadClick() {
        if (this.props.onUploadClick) {
            // prevent double-click
            this.setState({
               uploadEnabled: false
            });
            this.props.onUploadClick.call(null, this.filePicker.files);
        }
    }

    clear() {
        this.filePicker.value = '';
        this.onFileSelect(this.filePicker)
    }

    render() {
        return (
            <div className="row">
                <div className="col-xs-12 col-sm-8">
                    <div className="input-group form-inline">
                        <label className="input-group-btn">
                        <span className="btn btn-default">
                            Browse <input type="file"
                                          ref={instance => this.filePicker = instance}
                                          style={{display: 'none'}}
                                          multiple="multiple"
                                          onChange={this.onFileSelect}/>
                        </span>
                        </label>
                        <input type="text"
                               className="form-control"
                               style={{textOverflow: 'ellipsis'}}
                               readOnly="readOnly"
                               value={this.state.statusText}/>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-4 m-t-sm-c-xs">
                    {this.state.uploadVisible &&
                    <button className="btn btn-primary"
                            onClick={this.onUploadClick}
                            disabled={!this.state.uploadEnabled}>Upload

                        {this.state.selectedCount > 0 &&
                        <span className="hidden-xs hidden-sm"> {this.state.selectedCount} file{1 === this.state.selectedCount ? '' : 's'}</span>}
                    </button>}
                </div>
            </div>
        )
    }
}

FancyFileUpload.propTypes = {
    onUploadClick: React.PropTypes.func
};

export default FancyFileUpload;



// WEBPACK FOOTER //
// ./src/modules/views/common/FancyFileUpload.js